// extracted by mini-css-extract-plugin
export default {"letterSpacing":"index_letterSpacing__nlmUD","MenuItemWrapper":"index_MenuItemWrapper__HUZgx"};